<template>
	<div class="check-container">
		<div class="check-panel">
			<div class="title">审核</div>
			<div class="check-main">
				<a-radio-group @change="onChange" v-model="value">
					<a-radio value="1">通过并发送结果</a-radio>
					<a-radio value="2">不通过</a-radio>
				</a-radio-group>
				<div class="check-text" v-if='value=="2"'>
					<div>
                         <textarea name="" v-model='reason' placeholder='请输入审核意见或原因'>

                         </textarea>
					</div>
				</div>
				<div style=" margin:24px 0;" v-if='value=="1"'></div>
				<div class="button-group">
					<a-button type="primary" @click='toCheck()' :loading="isHttpSubmit"> 确定</a-button>
					<a-button style='margin-left:30px' @click="cancel()"> 取消</a-button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

  export default {
    data() {
      return {
        value: '1',
        reason: '',
        isHttpSubmit: false,
      }
    },
    props: ['id', 'verifyStatus'],
    methods: {
      onChange(e) {
      },
      cancel() {
        this.$emit('update', 2);
        this.$emit('close');
      },
      toCheck() {
        let data = {}
        this.isHttpSubmit = true;
        if (this.value == '2') {
          data = {
            "id": this.id,
            "verifyRemark": this.reason,
            "verifyStatus": this.value
          }
        } else {
          data = {
            "id": this.id,
            "verifyStatus": this.value
          }
        }
        this.$post(
          "jobsmanage/jobs/verifyJobByJobId",
          data,
          true
        ).then(res => {
          if (res.data.code == 1) {
            this.$emit('update', 2)
            this.$emit('close')
          } else {
            this.$message.error(res.data.message)
          }
          this.isHttpSubmit = false;
        }).catch(err => {
          this.isHttpSubmit = false;
          this.$message.error(err.data.message)
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
	.check-container {
		.check-panel {
			width: 482px;
			margin: 0 auto;
			.title {
				padding: 82px 0 56px 0;
				height: 25px;
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
			}
			.check-main {
				width: 482px;
				height: 377px;
				background: rgba(255, 255, 255, 1);
				border: 1px solid rgba(243, 245, 247, 1);
				padding: 30px 0 10px 48px;
				.check-text {
					width: 386px;
					height: 202px;
					background: rgba(255, 255, 255, 1);
					border: 1px solid rgba(66, 142, 247, 1);
					margin: 24px 0;
					textarea {
						border: 0 none;
						outline: 0 none;
						width: 100%;
						height: 100%;
						padding: 5px 10px;
						font-size: 12px;
					}
				}
			}
		}

		.detrusion-main {
			width: 510px;
			margin: 0 auto;
		}

		.dtree-select {
			height: 350px;
		}
	}
</style>